import type {WorkstreamMetric} from 'client';

export const getPreviousQuarterPeriod = (year: number, quarter: number) =>
  quarter === 1 ? `${year - 1}Q4` : `${year}Q${quarter - 1}`;

const hasDefinedValue = (value?: string | null) =>
  Boolean(value?.trim()) && value?.trim().toUpperCase() !== 'N/A';

export const metricNeedsActualForPeriod = (metric: WorkstreamMetric, period: string) => {
  const forecast = metric.metric_forecasts?.find((item) => item.period === period);
  return (
    (hasDefinedValue(forecast?.target) || hasDefinedValue(forecast?.budget)) &&
    !hasDefinedValue(forecast?.actual)
  );
};

export const buildMetricActualUpdate = (
  metric: WorkstreamMetric,
  period: string,
  value: string
): Partial<WorkstreamMetric> => {
  const forecasts = metric.metric_forecasts ?? [];
  const actual = value.trim() || null;
  const existing = forecasts.find((forecast) => forecast.period === period);
  if (!existing && actual === null) return {};

  return {
    metric_forecasts: existing
      ? forecasts.map((forecast) => (forecast.period === period ? {...forecast, actual} : forecast))
      : ([
          ...forecasts,
          {period, target: '', budget: null, actual},
        ] as WorkstreamMetric['metric_forecasts']),
  };
};
